import React from 'react'
import {
  Card,
  Col,
  Button,
  Row,
} from 'react-bootstrap'

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError(error) {
    console.log('error', error)
    return { hasError: true }
  }

  componentDidCatch(error, errorInfo) {
    // TODO: log error
    console.log(error, errorInfo)
  }

  render() {
    if (this.state.hasError) {
      return (
        <Row>
          <Col md={{ span: 6, offset: 3 }}>
            <Card>
              <Card.Header>
                <i className="fa fa-bomb" />
              </Card.Header>
              <Card.Body className="text-center">
                <p className="lead">An unexpected error occurred.</p>

                <Button variant="primary" onClick={() => { window.location.reload() }}>
                  Reload
                </Button>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      )
    }

    return this.props.children
  }
}

export default ErrorBoundary
